















































































































































// --- Vue & Template imports ---
import { Component, Prop, Vue } from 'vue-property-decorator';

// --- Services ---
import AuthService from '@/services/auth';
import AppService from '@/services/app';
import MomentumService from '@/services/momentum';

// --- Third Party imports ---

@Component
export default class Momentum extends Vue {
  momentumCode: string = '';
  valid: boolean = false;
  cancelClicked: boolean = false;
  clicked: boolean = false;
  loader: string = '';
  cost: string = process.env.VUE_APP_TEST_COST;
  isMomentumMember = false;
  rules = {
    required: (value: string) => !!value || '',
  };

  // Functions

  async notAMember() {
    try {
      this.cancelClicked = true;
      const response = await MomentumService.notMomentumMember({ isMomentumMember: this.isMomentumMember });

      if (response.data.result === 'false') {
        AppService.errorHandler(this.$store.getters['app/messages'].couldNotConnect);
      } else {
        // don't tell the user anything, just redirect them
        //AppService.successHandler(response.data.message);

        // refectch the user's data now because it has changed
        await AuthService.getLoggedInUser();
        this.$router.push({ name: 'Payment' });
      }

    } catch (error) {
      if (error.response) {
        AppService.errorHandler(error.response.statusText);
      } else {
        AppService.errorHandler(this.$store.getters['app/messages'].couldNotConnect);
      }

    } finally {
      this.cancelClicked = false;
    }
  }

  async getDiscount() {
    try {
      this.clicked = true;
      this.loader = 'clicked';
      const transactionIdentifier = 'ocg_' + new Date().getTime();
      const response = await MomentumService.getMomentumDiscount({ momentumCode: this.momentumCode, 
        transactionValue: process.env.VUE_APP_TEST_COST, transactionIdentifier: transactionIdentifier });

      if (response.data.result === 'false') {
        AppService.errorHandler(response.data.message);
      } else {
        AppService.successHandler('You have received a discount of R' + response.data.message);

        this.$router.push({ name: 'Payment', params: {
            discountAmount: '' + response.data.message, 
          }});
      }

    } catch (error) {
      if (error.response) {
        AppService.errorHandler(error.response.statusText);
      } else {
        AppService.errorHandler(this.$store.getters['app/messages'].couldNotConnect);
      }

    } finally {
      this.clicked = false;
      this.loader = '';
    }
  }

}
